import Logger from "./Logger";
const TAG = 'JSEventUtils';
export default class JSEventUtils {
    static stopEventPropagation(event) {
        if (event && event.preventDefault && event.stopPropagation) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            Logger.error(TAG, "Invalid event passed to JSEventUtils::stopEventPropagation()");
        }
    }
    static stopOnlyEventPropagation(event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        else {
            Logger.error(TAG, "Invalid event passed to JSEventUtils::stopOnlyEventPropagation()");
        }
    }
}
//# sourceMappingURL=JSEventUtils.js.map